/**
 * setLanguageMixin()
 * page refresh 시
 * session storage에 저장된 language code로
 * 언어 설정 초기화
 */
// eslint-disable-next-line import/prefer-default-export
export const setLanguageMixin = {
  created() {
    const langCode = sessionStorage.getItem('langCode');
    if (langCode) this.$i18n.set(langCode);
  },
};
